import { render, staticRenderFns } from "./IconFilter.vue?vue&type=template&id=2760ee0c&scoped=true&"
import script from "./IconFilter.vue?vue&type=script&lang=ts&"
export * from "./IconFilter.vue?vue&type=script&lang=ts&"
import style0 from "./IconFilter.vue?vue&type=style&index=0&id=2760ee0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2760ee0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
